import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { Menu } from "@components/menu/menu"
import { LinkType } from "@types/link-type"

const StyledHeader = styled.header`
  position: fixed;
  height: 0;
  top: 1rem;
  left: 0;
  right: 0;
  z-index: 500;
`

const Header = ({
  landingPage,
  links,
  productOverride,
  login
}) => {
  const [mobileState, setMobileState] = useState(false)

  return (
    <StyledHeader>
        <Menu
          mobileState={mobileState}
          setMobileState={setMobileState}
          landingPage={landingPage}
          links={links}
          productOverride={productOverride}
          login={login}
        />
    </StyledHeader>
  )
}

Header.propTypes = {
  landingPage: PropTypes.bool,
  links: PropTypes.arrayOf(LinkType),
  productOverride: PropTypes.number,
  login: PropTypes.bool,
}

export default Header
